import React from "react";
import { Link } from "react-router-dom";
import "../styles/privacy_policy.css";

const SUPPORT_EMAIL = "isfinformaticaanalytica@gmail.com";

const RefundPolicy = () => {
  return (
    <div className="privacy-policy-container">
      <div className="privacy-policy-content">
        <h1 className="privacy-title">Refund Policy for Skill Master</h1>
        <p className="last-updated">Last updated: November 5, 2026</p>

        <p className="intro-text">
          This Refund Policy applies to all purchases made on Skill Master (skillmaster.net.in),
          operated by ISF Analytica &amp; Informatica Pvt. Ltd. ("we", "our", or "us"). Skill Master
          sells digital learning content such as e-books and courseware, which is made available to
          you immediately after a successful payment. Please read this policy before making a purchase.
        </p>

        <section className="policy-section">
          <h2 className="section-title">1. Digital Content</h2>
          <p>
            Because our products are digital and are delivered instantly, purchases are generally
            non-refundable once the content has been unlocked in your account. We encourage you to
            review the book or course details before you buy.
          </p>
        </section>

        <section className="policy-section">
          <h2 className="section-title">2. When You Are Eligible for a Refund</h2>
          <p>We will refund your payment in full in the following cases:</p>
          <ul className="policy-list">
            <li>
              <strong>Duplicate payment:</strong> You were charged more than once for the same book
              or course.
            </li>
            <li>
              <strong>Payment debited but content not delivered:</strong> Money was deducted from your
              account but the purchase was not unlocked in your Skill Master account, and we are unable
              to unlock it.
            </li>
            <li>
              <strong>Content not accessible:</strong> The content you purchased cannot be opened due to
              a technical problem on our side, and our support team is unable to fix it within
              7 working days of your complaint.
            </li>
            <li>
              <strong>Wrong content:</strong> The content delivered is materially different from what
              was described on the product page.
            </li>
          </ul>
        </section>

        <section className="policy-section">
          <h2 className="section-title">3. When a Refund Is Not Available</h2>
          <ul className="policy-list">
            <li>You changed your mind after the content was unlocked.</li>
            <li>You purchased the wrong item by mistake and have already opened it.</li>
            <li>Your device, browser, or internet connection does not meet the basic requirements to view the content.</li>
            <li>The request is made more than 7 days after the date of purchase.</li>
            <li>Free content, or content obtained through a promotional offer or coupon.</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2 className="section-title">4. How to Request a Refund</h2>
          <p>
            Email us at <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a> within 7 days of the
            purchase with the following details:
          </p>
          <ul className="policy-list">
            <li>The email address registered on your Skill Master account.</li>
            <li>The name of the book or course.</li>
            <li>The Transaction ID shown on the payment page or in your payment confirmation.</li>
            <li>A short description of the problem, with a screenshot if possible.</li>
          </ul>
          <p>We will acknowledge your request within 2 working days.</p>
        </section>

        <section className="policy-section">
          <h2 className="section-title">5. Refund Processing</h2>
          <ul className="policy-list">
            <li>Approved refunds are issued to the original payment method used for the purchase (card, UPI, or net banking). We do not refund in cash or to a different account.</li>
            <li>Once approved, refunds are initiated within 5 to 7 working days. The time it takes for the amount to reach your account depends on your bank or card issuer.</li>
            <li>When a refund is issued, access to the related content is removed from your account.</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2 className="section-title">6. Failed Payments</h2>
          <p>
            If a payment fails but the amount is debited from your account, it is usually reversed
            automatically by your bank or by our payment partner within 5 to 7 working days. If it has
            not been reversed after that, contact us with the Transaction ID and we will help.
          </p>
        </section>

        <section className="policy-section">
          <h2 className="section-title">7. Cancellations</h2>
          <p>
            For cancelling an order, please see our{" "}
            <Link to="/cancellation_policy">Cancellation Policy</Link>.
          </p>
        </section>

        <section className="policy-section">
          <h2 className="section-title">8. Changes to This Policy</h2>
          <p>
            We may update this Refund Policy from time to time. The version published on this page at
            the time of your purchase applies to that purchase.
          </p>
        </section>

        <section className="policy-section">
          <h2 className="section-title">9. Contact Us</h2>
          <div className="contact-info">
            <p><strong>ISF Analytica &amp; Informatica Pvt. Ltd.</strong></p>
            <p>Chembur, Mumbai, Maharashtra, India</p>
            <p>Email: <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a></p>
            <p>Website: <a href="https://skillmaster.net.in" target="_blank" rel="noopener noreferrer">https://skillmaster.net.in</a></p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default RefundPolicy;
